module.exports = __webpack_public_path__ + "img/icon_erro.15fe1814.svg";